import React from "react";

import "./SuccessSlide.scss";
export default function SuccessSlide(props) {
	return (
		<div className="success-slide">
			<img
				className="success-image"
				src={props.imgURL}
				alt="success-img"
			/>
			<div className="success-name">{props.name}</div>
			<div className="success-date">Matched {props.dateMatched}</div>
		</div>
	);
}
